export default "__VITE_ASSET__BbMdS7tA__"